import { usePageContext } from "@/lib/brand";
import { useFund, TickerBadge } from "@/components/site/FundBits";
import { money, pct, aum, fee, distAmt } from "@/lib/api";

const TABS = ["Overview", "Distributions", "Portfolio", "Performance", "Documents"];

export default function FundPage() {
  const { ticker } = usePageContext();
  const card = useFund(ticker);
  if (card === false) return <p className="mx-auto max-w-[1280px] px-6 py-24">Fund not found.</p>;
  if (!card) return <div className="h-[60vh] bg-hv-section" />;
  const c = card.classes.find((x) => x.ticker === ticker) || card.classes[0];
  const facts = [
    ["Ticker", c.ticker, "TSX"], ["NAV", money(c.nav), "Updated daily"], ["Mkt price close", money(c.market_price), "Updated daily"],
    ["Net AUM", aum(c.aum_m), "Updated daily"], ["Current yield", c.current_yield_pct != null ? pct(c.current_yield_pct) : "—", c.current_yield_note ? "See note" : "Updated daily"],
    ["Cash distribution", c.distribution_frequency, "Frequency"], ["Last distribution", distAmt(c.last_distribution), "Cash, per unit"],
    ["Risk rating", c.risk_rating, ""], ["Mgmt. fee", fee(c.mgmt_fee_pct), ""],
  ];
  return (
    <>
      <section className="hv-hero text-white" data-testid="fund-page-hero">
        <div className="mx-auto max-w-[1280px] px-6 py-16">
          <TickerBadge ticker={c.ticker} brand={card.brand} className="h-14" />
          <h1 className="mt-6 font-heading text-3xl font-bold sm:text-4xl lg:text-5xl" data-testid="fund-page-title">{card.fund_name}</h1>
          <p className="mt-3 text-white/80">{card.category} · TSX: {c.ticker}</p>
        </div>
      </section>
      <nav aria-label="Fund sections" className="border-b border-hv-rule bg-white">
        <div className="mx-auto flex max-w-[1280px] gap-8 overflow-x-auto px-6 font-heading text-sm font-semibold uppercase tracking-wider">
          {TABS.map((tb, i) => <span key={tb} className={`py-4 ${i === 0 ? "border-b-2 border-hv-navy text-hv-navy" : "text-hv-muted"}`}>{tb}</span>)}
        </div>
      </nav>
      <section className="bg-hv-section">
        <div className="mx-auto max-w-[1280px] px-6 py-16">
          <h2 className="font-heading text-2xl font-bold">Key Facts</h2>
          <p className="mt-1 text-sm text-hv-muted">As at {c.as_at} (end-of-day)</p>
          <dl className="mt-8 grid gap-px bg-hv-rule sm:grid-cols-3" data-testid="fund-key-facts">
            {facts.map(([k, v, s]) => (
              <div key={k} className="bg-white p-6">
                <dt className="font-heading text-xs font-semibold uppercase tracking-wider text-hv-muted">{k}</dt>
                <dd className="mt-2 font-heading text-2xl font-bold text-hv-navy">{v}</dd>
                {s && <dd className="mt-1 text-xs text-hv-muted">{s}</dd>}
              </div>
            ))}
          </dl>
          {c.current_yield_note && <p className="mt-6 text-sm text-hv-text">{c.current_yield_note}</p>}
        </div>
      </section>
    </>
  );
}
